import React from "react";
import "../styles/Links.css";

const Links = () => {
  return (
    <section className="driving-links">
      <h3 className="links-title">
        <span className="nowrap-mobile">Book or Manage </span>
        <span className="mobile-break">
          <br />
        </span>
        Your Tests
      </h3>

      <div className="link-container">
        <div className="box">
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={55}
              height={55}
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M6 22q-.825 0-1.412-.587T4 20V4q0-.825.588-1.412T6 2h12q.825 0 1.413.588T20 4v16q0 .825-.587 1.413T18 22zm0-2h12V4h-2v7l-2.5-1.5L11 11V4H6zm0 0V4zm5-9l2.5-1.5L16 11l-2.5-1.5z"
              ></path>
            </svg>
          </div>
          <p>Book Theory Test</p>{" "}
          <a
            href="https://www.gov.uk/book-theory-test"
            rel="noreferrer"
            target="_blank"
            className="book-now"
          >
            {" "}
            Book Now
          </a>
        </div>
      </div>
      <div className="link-container">
        <div className="box">
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={55}
              height={55}
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m5 11l1.5-4.5h11L19 11m-1.5 5a1.5 1.5 0 0 1-1.5-1.5a1.5 1.5 0 0 1 1.5-1.5a1.5 1.5 0 0 1 1.5 1.5a1.5 1.5 0 0 1-1.5 1.5m-11 0A1.5 1.5 0 0 1 5 14.5A1.5 1.5 0 0 1 6.5 13A1.5 1.5 0 0 1 8 14.5A1.5 1.5 0 0 1 6.5 16M18.92 6c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L3 12v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8z"
              ></path>
            </svg>
          </div>
          <p>Book Practical Test</p>{" "}
          <a
            href="https://www.gov.uk/book-driving-test"
            rel="noreferrer"
            target="_blank"
            className="book-now"
          >
            {" "}
            Book Now
          </a>
        </div>
      </div>
      <div className="link-container">
        <div className="box">
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={55}
              height={55}
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M19 4h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-7h16Zm0-9H4V7a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0V6h6v1a1 1 0 0 0 2 0V6h2a1 1 0 0 1 1 1Z"
              ></path>
            </svg>
          </div>
          <p>Manage Test</p>{" "}
          <a
            href="https://www.gov.uk/change-driving-test"
            rel="noreferrer"
            target="_blank"
            className="book-now"
          >
            {" "}
            Book Now
          </a>
        </div>
      </div>
    </section>
  );
};

export default Links;
